import Vue from "vue";
import moment from "moment";

Vue.component("file-upload-table", {
    props: ["attachmenttype",
        "language",
        "vmdata",
        "tableref",
        "isreadonly",
        "iswithdialects",
        "attachmentLabel",
        "uploadLabel",
        "languageLabel",
        "attachmentTypeLabel",
        "uploadingText",
        "fileAttachmentLabel",
        "allowedTypes",
        "showTypes"
    ],
    data() {
        return {
            fileData: [],
            filteredData: [],
            tableWithDialects: false,
            fileUploadTableDialects: [],
            files: [],
            forUploading: [],
            hasData: false,
            isRemoveAttachment: false,
            attachmentTypes: []
        };
    },
    methods: {
        getDialects: function () {
            this.$services.dialectsService.getDropdownItems({
                language: window.currentLanguageInt
            })
                .then((data) => {
                    let dialects = data;
                    data.forEach(function (item, index) {
                        switch (item.id) {
                            case "EN":
                                data.splice(index, 1);
                                dialects.splice(0, 0, item);
                                break;
                            case "FR":
                                data.splice(index, 1);
                                dialects.splice(1, 0, item);
                                break;
                            case "ES":
                                data.splice(index, 1);
                                dialects.splice(2, 0, item);
                                break;
                        }
                    })
                    this.fileUploadTableDialects = dialects;
                });
        },
        getAttachmentTypes: function () {
            this.$services.attachmentTypesService.getDropdownItems({
                language: window.currentLanguageInt
            })
                .then((data) => {
                    console.log(this.allowedTypes);
                    if (data && this.allowedTypes) {
                        this.attachmentTypes = data.filter(item => this.allowedTypes.includes(item.id));

                    } else {
                        this.attachmentTypes = data;

                    }
                });
        },
        removeAttachment: function (fileName) {
            this.isRemoveAttachment = true;

            this.filteredData = this.filteredData.filter(item => item.fileName != fileName);
            this.files = this.files.filter(item => item.name != fileName);

            this.$emit("update:vmdata", this.filteredData);
        },
        downloadFile: function (id, guid, name) {44444
            let url = `/api/attachments/download?id=${id}&guid=${guid}&fileName=${name}`;
            window.open(url);
        }
    },
    mounted: function () {


        this.getDialects();
        this.getAttachmentTypes();
        this.tableWithDialects = this.iswithdialects;


        if (this.vmdata) {
            this.fileData = this.vmdata;
            this.hasData = true;
        }
    },
    watch: {
        fileData: function (val) {
            let result = [];

            if (this.hasData) {
                result = this.filteredData;
                val.forEach(function (item) {
                    let newAttachment = result.filter(attachment => attachment.fileName == item.fileName);
                    if (newAttachment.length == 0) {

                        result.push(item);
                    }
                });
            } else {
                result = val;
            }

            this.filteredData = result;
            this.$emit("update:vmdata", result);
        },
        files: function () {
            if (!this.isRemoveAttachment) {
                let vm = this;
                let file = vm.files;

                let formData = new FormData();
                for (let i = 0; i < file.length; i++) {
                    formData.append('files', file[i], file[i].name)
                }

                //formData.append('attachmentTypeId', vm.attachmenttype)
                formData.append('language', vm.language)
                //formData.append('', vm.language)

                if (file.length > 0) {
                    let isExisting = true;
                    let fileDate = moment().format('MM/D/yyyy h:mm:ss');
                    vm.filteredData.forEach(function (item) {
                        isExisting = file.filter(fileItem => fileItem.fileName == item.fileName).length > 0;

                    })

                    if (!isExisting || vm.filteredData.length == 0) {
                        vm.forUploading.push({ date: fileDate });
                    }

                    vm.$services.attachmentsService.uploadFile(formData)
                        .then((response) => {
                            let result = response.data.items;
                            if (result.length > 0) {
                                vm.fileData = result;
                            }

                            setTimeout(function () { vm.forUploading = vm.forUploading.filter(item => item.date != fileDate); }, 1000);
                        });
                }
            }

            this.isRemoveAttachment = false;
        },
    },
    template: `
		<div class="columns">
			<div class="column">
				<b-field :label="fileAttachmentLabel">
					<b-table bordered striped
							 :narrowed="true"
							 :hoverable="true"
							 :data="filteredData"
							 :show-detail-icon="false"
							 ref="tableref"
							 detailed
							 detail-key="id">

						
						<b-table-column v-if="tableWithDialects" field="language" :label="languageLabel" width="15%" v-slot="props">
							<b-select v-if="!isreadonly" v-model="props.row.dialectCode" expanded>
								<option v-for="option in fileUploadTableDialects"
										:value="option.id"
										:key="option.id">
									{{ option.text }}
								</option>
                                
							</b-select>
                            <div v-else>
                                {{ props.row.dialectName }}
                            </div>
						</b-table-column>
                        <b-table-column :visible="showTypes" field="attachmentType" :label="attachmentTypeLabel" width="15%" v-slot="props">
	                        <b-select v-if="!isreadonly" v-model="props.row.attachmentTypeId" expanded>
		                        <option v-for="option in attachmentTypes"
				                        :value="option.id"
				                        :key="option.id">
			                        {{ option.text }}
		                        </option>
                          
	                        </b-select>
                            <div v-else>
                                {{ props.row.attachtmentTypeName }}
                            </div>
                        </b-table-column>
						<b-table-column field="attachments" :label="attachmentLabel | decodeHTMLEntity" width="60%" v-slot="props">
							{{ props.row.fileName }}
						</b-table-column>

						<b-table-column field="" label="" width="10%" v-slot="props">
							<a @click="downloadFile(props.row.id, props.row.guid, props.row.fileName)">
								<i class="fas fa-download has-text-primary"></i>
							</a>
							<a v-if="!isreadonly"  @click="removeAttachment(props.row.fileName)">
								<i class="fas fa-trash-alt has-text-danger"></i>
							</a>
						</b-table-column>
					</b-table>
				</b-field>
		
				<div class="columns">
					<div class="column" v-for="(item, index) in forUploading" :key="index">
						<b-progress type="is-success" size="is-medium" show-value>
							<span style="color: black">{{ uploadingText }}...</span>
						</b-progress>
					</div>
				</div>

				<b-field v-if="!isreadonly" class="file is-danger">
					<b-upload v-model="files" accept=".pdf,.doc,.docx,.xls,.xlsx,.odt,.ods" :multiple="true" class="file-label">
						<span class="file-cta">
							<b-icon class="file-icon" icon="upload"></b-icon>
							<span class="file-label">{{ uploadLabel | decodeHTMLEntity }}</span>
						</span>
					</b-upload>
				</b-field>

			</div>
		</div>
	`
});